import { createRouter, createWebHistory } from 'vue-router'
import Layout from '@/views/authorized/Layout.vue';
import Home from '@/views/authorized/Home.vue';
import Account from '@/views/authorized/Account.vue';
import RoleManager from '@/views/authorized/RoleManager.vue';
import UserManager from '@/views/authorized/UserManager.vue';
import DirectoryManager from '@/views/authorized/DirectoryManager.vue';
import UploadLog from '@/views/authorized/UploadLog.vue';
import ForgotPassword from '@/views/account/ForgotPassword.vue';
import ResetPassword from '@/views/account/ResetPassword.vue';
import Verify2FA from '@/views/account/Verify2FA.vue';
import LoginByOtp from '@/views/account/LoginByOtp.vue';

import accountRoutes from './account.routes.js';

import useAlertStore from '@/stores/alert.store.js';
import axios from 'axios';
import { authService } from "@/services/auth-service.js";

axios.defaults.withCredentials = true;

export const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    linkActiveClass: 'active',
    routes: [
        {
          path: '/',
          component: Layout,
          children: [
              { path: '', component: Home, meta: { fluid: true } },
              { path: '/user-manager', component: UserManager, meta: { requireRole: 'admin' } },
              { path: '/role-manager', component: RoleManager, meta: { requireRole: 'admin' } },
              { path: '/directory-manager', component: DirectoryManager, meta: { requirePermission: 'manage user directories' } },
              { path: '/uploads', component: UploadLog },
              { path: '/account', component: Account },
            ]
        },
        { ...accountRoutes },
        { path: '/login-by-otp', component: LoginByOtp },
        { path: '/forgot-password', component: ForgotPassword },
        { path: '/reset-password', component: ResetPassword },
        { path: '/2fa/verify', component: Verify2FA },
        { path: '/:pathMatch(.*)*', redirect: '/' }
    ]
});

router.beforeEach(async (to, from) => {
    const alertStore = useAlertStore();
    alertStore.clear();

    const publicPages = ['/login', '/forgot-password', '/reset-password', '/2fa/verify', '/login-by-otp'];
    const isPublic = publicPages.includes(to.path);

    if (isPublic) return true;

    try {
        const data = await authService.get_session();
        if (!data) {
            return '/login';
        }

        // The backend is still the real gate. These checks only stop a
        // non-authorized user from loading the page shell after typing
        // the URL or following a stale link.
        const requiredRole = to.meta?.requireRole;
        if (requiredRole) {
            const userRole = data.user?.role?.name?.toLowerCase();
            if (userRole !== requiredRole.toLowerCase()) {
                return '/';
            }
        }

        const requiredPermission = to.meta?.requirePermission;
        if (requiredPermission) {
            const userPerms = data.user?.permissions || [];
            if (!userPerms.includes(requiredPermission)) {
                return '/';
            }
        }

        return true;
    } catch (e) {

        return '/login';
    }
});

export default router;